module.exports = __webpack_public_path__ + "static/img/box@2x.c9f90de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/box@2x.png
// module id = u7hH
// module chunks = 0